import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { Globe, Loader2 } from "lucide-react";
import Header from "../components/Header";
import Footer from "../components/Footer";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// ISO -> flag emoji helper
const flag = (cc) => cc.toUpperCase().replace(/./g, (c) => String.fromCodePoint(127397 + c.charCodeAt(0)));

export default function ForeignStations() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState("");

  useEffect(() => {
    axios.get(`${API}/news/foreign-stations`, { timeout: 12000 })
      .then((r) => setData(r.data))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  const countries = (data?.countries || []).filter((c) =>
    !filter || c.name.toLowerCase().includes(filter.toLowerCase())
  );

  return (
    <>
      <Header onOpenBrief={() => {}} />
      <main className="max-w-[1280px] mx-auto px-5 py-8">
        <div className="section-title">
          <span className="pip" />
          <h2 data-testid="foreign-title">Foreign Stations</h2>
          <span className="ml-auto text-[10px] uppercase tracking-[0.16em] font-bold text-[var(--muted)]" data-testid="foreign-counts">
            {data ? `${data.total_stations} stations · ${data.total_countries} countries` : ""}
          </span>
        </div>
        <p className="text-[13.5px] text-[var(--muted)] mt-1 max-w-[820px]" data-testid="foreign-tagline">
          Every independent newsroom Newseze follows outside the United States — no state-sponsored outlets,
          no propaganda. Click any country to read the latest from its stations.
        </p>

        <input
          type="text"
          placeholder="Filter by country…"
          value={filter}
          onChange={(e) => setFilter(e.target.value)}
          className="field mt-5 w-full max-w-[360px]"
          data-testid="foreign-filter"
        />

        {loading ? (
          <div className="flex justify-center py-12"><Loader2 className="animate-spin text-[var(--blue)]" /></div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 mt-6">
            {countries.map((c) => (
              <Link
                key={c.code}
                to={`/section/world?country=${c.code}`}
                className="rounded-xl border border-[var(--line)] bg-white p-4 hover:border-[var(--blue)] transition"
                data-testid={`foreign-country-${c.code}`}
              >
                <div className="flex items-center gap-2 mb-2">
                  <span className="text-[20px]">{flag(c.code)}</span>
                  <span className="text-[14px] font-black text-[var(--ink)]">{c.name}</span>
                  <span className="ml-auto text-[10px] uppercase tracking-[0.14em] font-bold text-[var(--blue)]">{c.code}</span>
                </div>
                <ul className="space-y-1 text-[12.5px]">
                  {c.stations.map((s) => (
                    <li key={s.name} className="flex items-center justify-between gap-2">
                      <span className="text-[var(--ink)]">{s.name}</span>
                      <span className="text-[10px] uppercase tracking-[0.14em] font-bold text-[var(--muted)]">
                        {s.count} stories
                      </span>
                    </li>
                  ))}
                </ul>
              </Link>
            ))}
          </div>
        )}
      </main>
      <Footer />
    </>
  );
}
